import { dispatch } from '@rematch/core';

export default {
    state: {
        authCalled: false
    },
    reducers: {
        setAuthCalled(state) {
            return {
                ...state,
                authCalled: true
            }
        },
    },
    effects: {
        async handle(payload, rootState) {
            dispatch.login.logout();
        }
    }
}